export default __webpack_public_path__ + "static/media/parent-label.24de04ab.svg";